<template>

  <mdb-container class="mt-2">

    <jumbotron :subtitle="$t('personDetails.subtitle')" :title="$t('personDetails.title')"></jumbotron>

    <mdb-row>

      <mdb-col col="sm-12">

        <div class="input-border">

          <mdb-input :label="$t('personDetails.number')" :value="persons.count" size="lg" @input="syncPersons"/>

        </div>

      </mdb-col>

    </mdb-row>


    <!--    Next button-->
    <mdb-row class="justify-content-center mt-3">
      <mdb-col>
        <mdb-btn v-if="persons.count && persons.count !== '0'" block class="large-button btn-primary"
                 @click="next">
          {{ $t('general.next') }}
        </mdb-btn>
      </mdb-col>
    </mdb-row>

  </mdb-container>

</template>

<script>

import {mapActions, mapGetters} from "vuex";

export default {

  name: 'PersonDetails',

  metaInfo() {
    return {
      title: this.$t('personDetails.metaTitle')
    }
  },

  mounted() {
    this.updateIsLoading(true);

    this.$http.getPersonFreeText()
        .then(({data}) => {
          if (data.success) {
            this.updatePersons({
              id: data.data.id,
              title: data.data.title,
              min: parseInt(data.data.min, 0),
              max: parseInt(data.data.max, 0),
              count: this.persons.count
            })
          }
        })
        .finally(() => this.updateIsLoading(false))
  },

  computed: {
    ...mapGetters({persons: "getPersons"})
  },

  methods: {
    ...mapActions(["updatePersons", "updateIsLoading"]),

    next() {
      this.$router.push({name: 'SeatingType'});
    },

    syncPersons(count) {
      if(isNaN(count) || count ===""){
        count = null
      }else{
        count = parseInt(count, 10);

        // check if the persons count is in the range'
        if(count < this.persons.min ){
          count = this.persons.min;
        }
        if (count > this.persons.max) {
          count = this.persons.max;
        }
      }
      this.updatePersons({
        ...this.persons,
        count: count
      })

    }
  }
}
</script>

<style lang="scss" scoped>
@import "_index.scss";
</style>


// WEBPACK FOOTER //
// src/components/pages/person-details/index.vue